import {useCallback, useEffect, useState} from "react";
import {IconButton, SelectableTableHeader, TableWithSelect} from "zavadil-react-common";
import {PagingRequest} from "zavadil-ts-common";
import {User} from "../../../types/User";
import {useRestClient} from "../../../client/SpmRestClient";
import {useAlerts} from "../../../utils/UserAlerts";
import {useNavigate} from "react-router";
import {Spinner, Stack} from "react-bootstrap";
import {BsPlus} from "react-icons/bs";

const HEADER: SelectableTableHeader<User> = [
	{name: "name", label: "Jméno"},
	{name: "email", label: "Email"},
	{name: "userRole", label: "Uživatelské role", renderer: (u: User) => u.roles.map(r => r.name).join(', ')},
];

const DEFAULT_PAGING: PagingRequest = {page: 0, size: 100, sorting: [{name: "lastUpdatedOn", desc: true}]};

export default function UsersList() {
	const restClient = useRestClient();
	const userAlerts = useAlerts();
	const navigate = useNavigate();
	const [data, setData] = useState<Array<User>>();

	const loadPageHandler = useCallback(() => {
		restClient
			.users
			.all()
			.then(setData)
			.catch((e: Error) => {
				setData(undefined);
				userAlerts.err(e);
			});
	}, [restClient, userAlerts]);

	useEffect(loadPageHandler, []);

	return (
		<div>
			<h1>Uživatelé</h1>
			<Stack direction="horizontal">
				<IconButton icon={<BsPlus/>} onClick={() => navigate('/admin/user')}>Nový</IconButton>
			</Stack>
			<div>
				{data === undefined ? (
					<Spinner/>
				) : (
					<TableWithSelect
						showSelect={false}
						header={HEADER}
						paging={DEFAULT_PAGING}
						totalItems={data.length}
						onPagingChanged={(p) => null}
						onClick={(item) => navigate(`/admin/user/${item.id}`)}
						items={data}
						hover={true}
						striped={true}
					/>
				)}
			</div>
		</div>
	);
}
